export enum YandexOrdOrganizationType {
  FL = 'fl', // Физическое лицо (РФ)
  UL = 'ul', // Юридическое лицо (РФ)
  IP = 'ip', // Индивидуальный предприниматель (РФ)
  FFL = 'ffl', // Иностранное физическое лицо
  FUL = 'ful', // Иностранное юридическое лицо
}

export enum YandexOrdAdvertisingDistributionForm {
  AUDIO_RECORDING = 'audio_recording', // аудиозапись
  BANNER = 'banner', // баннер
  HTML5_BANNER = 'html5_banner', // HTML5-баннер
  AUDIO_BROADCAST_LIVE = 'audio_broadcast_live', // аудиотрансляция в прямом эфире
  VIDEO_BROADCAST_LIVE = 'video_broadcast_live', // видеотрансляция в прямом эфире
  TEXT_BLOCK_WITH_AUDIO = 'text_block_with_audio', // текстовый блок с аудио
  TEXT_GRAPHIC_BLOCK_WITH_AUDIO_VIDEO = 'text_graphic_block_with_audio_video', // текстово-графический блок с аудио и видео
  TEXT_BLOCK = 'text_block', // текстовый блок
  TEXT_GRAPHIC_BLOCK_WITH_AUDIO = 'text_graphic_block_with_audio', // текстово-графический блок с аудио
  TEXT_BLOCK_WITH_AUDIO_VIDEO = 'text_block_with_audio_video', // текстовый блок с аудио и видео
  TEXT_GRAPHIC_BLOCK = 'text_graphic_block', // текстово-графический блок
  TEXT_GRAPHIC_BLOCK_WITH_VIDEO = 'text_graphic_block_with_video', // текстово-графический блок с видео
  TEXT_BLOCK_WITH_VIDEO = 'text_block_with_video', // текстовый блок с видео
  VIDEO_CLIP = 'video_clip', // видеоролик
}

export enum YandexOrdCampaignType {
  CPA = 'cpa', // СРА
  CPC = 'cpc', // СРС
  CPM = 'cpm', // СРМ
  OTHER = 'other', // Иное
}

export enum YandexOrdContractSubject {
  ADVERTISING_DISTRIBUTION = 'advertising_distribution', // Договор на распространение рекламы
  INTERMEDIATION = 'intermediation', // Посредничество
  REPRESENTATION = 'representation', // Представительство
  ORGANIZING_ADVERTISING_DISTRIBUTION = 'organizing_advertising_distribution', // Договор на организацию распространения рекламы
  OTHER = 'other', // Иное
}

export enum YandexOrdIntermediaryAction {
  COMMERCIAL_REPRESENTATION = 'commercial_representation', // Коммерческое представительство
  ADVERTISING_DISTRIBUTION = 'advertising_distribution', // Действия в целях распространения рекламы
  CONTRACT_CONCLUSION = 'contract_conclusion', // Заключение договоров
  OTHER = 'other', // Иное
}

export enum YandexOrdMediaType {
  AUDIO = 'audio', // аудио
  VIDEO = 'video', // видео
  ZIP_ARCHIVE = 'zip_archive', // ZIP-архив
  IMAGE = 'image', // изображение
  OTHER = 'other', // другое
}

export enum YandexOrdPlatformType {
  SITE = 'site',
  APPS = 'apps',
}

export enum YandexOrdRoleType {
  ADVERTISING_DISTRIBUTOR = 'advertising_distributor', // Рекламораспространитель
  ADVERTISING_SYSTEM_OPERATOR = 'advertising_system_operator', // Оператор рекламной системы
  ADVERTISING_AGENCY = 'advertising_agency', // Рекламное агентство
  ADVERTISER = 'advertiser', // Рекламодатель
}

export enum YandexOrdObjectType {
  ORGANIZATION = 'organization',
  CONTRACT = 'contract',
  CREATIVE = 'creative',
  INVOICE = 'invoice',
  CAMPAIGN = 'campaign',
  PLATFORMS = 'platforms',
  STATISTICS = 'statistics',
  INVOICE_CREATIVES = 'invoice/creatives',
}

export enum YandexOrdRequestStatus {
  REQUEST_ACCEPTED = 'Request accepted by ORD',
  ORD_SUCCESS = 'ORD success',
  ORD_ERROR = 'ORD error',
  ERIR_SYNC_SUCCESS = 'ERIR sync success',
  ERIR_ASYNC_SUCCESS = 'ERIR async success',
  ERIR_SYNC_ERROR = 'ERIR sync error',
  ERIR_ASYNC_ERROR = 'ERIR async error',
}

export enum YandexOrdContractType {
  CONTRACT = 'contract',
  INTERMEDIARY_CONTRACT = 'intermediary-contract',
  ADDITIONAL_AGREEMENT = 'additional-agreement',
}

export enum YandexOrdActionType {
  OTHER = 'other',
  COMMERCIAL = 'commercial',
  DISTRIBUTION = 'distribution',
  CONCLUDE = 'conclude',
}

export enum YandexOrdSubjectType {
  OTHER = 'other',
  REPRESENTATION = 'representation',
  MEDIATION = 'mediation',
  ORG_DISTRIBUTION = 'org-distribution', // Договор на организацию распространения рекламы (с рекламодателем)
  DISTRIBUTION = 'distribution', // Договор на распространение рекламы (с блогером)
}
